import {
  type Classification,
  type CurrencyCode,
  type CustomerSegment,
  EarlyAccessFeature,
  type ProductEnum,
  type TierModel,
} from "@doitintl/cmp-models";
import { type ModelReference, type ModelTimestamp } from "@doitintl/models-any";

export type SettingsValuesType = {
  currency: CurrencyCode;
  domains: { name: string; isPrimary: boolean }[];
  customerName: string;
  linesPerInvoice: number | null;
  cloudProvider: ProductEnum | null;
  customerClassification: Classification | null;
  earlyAccessFeatures: EarlyAccessFeature[];
  skipRemedyBreach: boolean;
  customerSegment: CustomerSegment | undefined;
  navigatorTierTrialStartDate: ModelTimestamp | null;
  navigatorTierTrialEndDate: ModelTimestamp | null;
  navigatorTierId?: string;
  navigatorTrialTier?: ModelReference<TierModel>;
  navigatorTrialCustomLength?: number | null;
  solveTierTrialStartDate: ModelTimestamp | null;
  solveTierTrialEndDate: ModelTimestamp | null;
  solveTierId?: string;
  solveTrialTier?: ModelReference<TierModel>;
};

export type SettingsTouchedFieldsType = {
  [K in keyof SettingsValuesType]?: boolean;
};

export const earlyAccessFeaturesOptions = [
  EarlyAccessFeature.FSGCP_DISABLED,
  EarlyAccessFeature.FSAWS_DISABLED,
  EarlyAccessFeature.FSGCP_MARKETPLACE_DISABLED,
  EarlyAccessFeature.FLEXSAVE_AWS_STANDALONE,
  EarlyAccessFeature.GCP_CLOUD_CONNECT_V2,
  EarlyAccessFeature.DISABLE_CREDIT_CARD_FEES,
  EarlyAccessFeature.ACCELERATOR_PROGRAM,
  EarlyAccessFeature.NOTIFICATION_CENTER,
  EarlyAccessFeature.THREADS,
  EarlyAccessFeature.FSK8S,
  EarlyAccessFeature.K8S_FEATURES,
  EarlyAccessFeature.FORECAST_BQ_ML,
  EarlyAccessFeature.AWS_MAP_LENS,
  EarlyAccessFeature.TRUSTED_ADVISOR_INSIGHTS,
  EarlyAccessFeature.COST_OPTIMIZATION_HUB_INSIGHTS,
  EarlyAccessFeature.GCP_RECOMMENDER_BIGQUERY_INSIGHTS,
  EarlyAccessFeature.AZURE_CLOUD_CONNECT,
];
